import React from 'react';

import { Frame, Video } from './styles';

const POSTER_PRELOAD = 'none';
const FIRST_FRAME_PRELOAD = 'metadata';

interface VideoFrameProps {
	src: string;
	poster?: string;
}

export function VideoFrame({ src, poster }: Readonly<VideoFrameProps>): JSX.Element {
	const preload = poster ? POSTER_PRELOAD : FIRST_FRAME_PRELOAD;

	return (
		<Frame>
			<Video src={src} poster={poster} preload={preload} muted playsInline />
		</Frame>
	);
}
